// {
//   "name": "iconic-testimonials-third.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-testimonials-third')) return;

  class IconicTestimonialsThird extends HTMLElement {
    constructor() {
      super();
      this.init = this.init.bind(this);
      this.stopAllVideosExcept = this.stopAllVideosExcept.bind(this);
    }

    connectedCallback() {
      console.log('[IconicTestimonialsThird] Connected to DOM');
      this.init();
    }

    init() {
      const listContainer = this.querySelector('.iconic-testimonials-list-main');
      if (!listContainer) {
        console.warn('[IconicTestimonialsThird] .iconic-testimonials-list-main not found');
        return;
      }

      const hoverPlay = listContainer.getAttribute('data-play') === 'true';
      console.log(`[IconicTestimonialsThird] Global hoverPlay = ${hoverPlay}`);

      const videoContainers = this.querySelectorAll('.iconic-top-content');
      console.log(`[IconicTestimonialsThird] Found ${videoContainers.length} containers`);

      videoContainers.forEach((container, index) => {
        const video = container.querySelector('video');
        const stickyIcon = container.querySelector('.iconic-sticky-icon');
        const playIcon = container.querySelector('.iconic-video-icon');

        if (!video) {
          console.warn(`[Item ${index}] No <video> found`);
          return;
        }

        if (hoverPlay) {
          // Hover behavior
          container.addEventListener('mouseenter', () => {
            console.log(`[Item ${index}] Mouseenter`);
            this.stopAllVideosExcept(container);
            video.play();
            if (stickyIcon) stickyIcon.style.display = 'none';
          });

          container.addEventListener('mouseleave', () => {
            console.log(`[Item ${index}] Mouseleave`);
            video.pause();
            if (stickyIcon) stickyIcon.style.display = 'flex';
          });

          if (playIcon) {
            playIcon.addEventListener('click', (e) => {
              e.stopPropagation();
              console.log(`[Item ${index}] Icon Click (hover mode)`);
              this.stopAllVideosExcept(container);
              video.play();
              if (stickyIcon) stickyIcon.style.display = 'none';
            });
          }
        } else {
          // Click-only behavior
          video.addEventListener('click', () => {
            this.togglePlay(video, container, stickyIcon, index);
          });

          if (playIcon) {
            playIcon.addEventListener('click', (e) => {
              e.stopPropagation();
              this.togglePlay(video, container, stickyIcon, index);
            });
          }
        }
      });
    }

    togglePlay(video, container, stickyIcon, index) {
      this.stopAllVideosExcept(container);

      if (video.paused) {
        video.play();
        if (stickyIcon) stickyIcon.style.display = 'none';
        console.log(`[Video ${index}] Playing`);
      } else {
        video.pause();
        if (stickyIcon) stickyIcon.style.display = 'flex';
        console.log(`[Video ${index}] Paused`);
      }
    }

    stopAllVideosExcept(activeContainer) {
      const all = this.querySelectorAll('.iconic-top-content');
      all.forEach((container, index) => {
        if (container !== activeContainer) {
          const video = container.querySelector('video');
          const stickyIcon = container.querySelector('.iconic-sticky-icon');

          if (video && !video.paused) {
            video.pause();
            console.log(`[Other Video ${index}] Paused`);
          }

          if (stickyIcon) {
            stickyIcon.style.display = 'flex';
            console.log(`[Other Video ${index}] Sticky icon shown`);
          }
        }
      });
    }
  }

  customElements.define('iconic-testimonials-third', IconicTestimonialsThird);
})();